import { AnnouncementBase } from '.';
import { Log } from '../../../AuxillaryService/Log';
import { ReachAPI } from '../../../ReachApi';
import { Scheduler, SchedulerItem } from '../../../Utility/Scheduler';
import { $ } from '../../../../vendor/jquery';
import { moment } from '../../../../vendor/moment';
import { AnnouncementWidget } from '../AnnouncementWidget';
import { ContentAnnouncementConfiguration } from '../types';
import type { PlayTimes } from '../PlayTimes';
import { contentBodyTemplate, contentTemplate } from '../Templates';

/**
 * @deprecated only used by legacy
 */
class AnnouncementContent extends AnnouncementBase {
    public declare configuration: ContentAnnouncementConfiguration;

    public constructor(
        configuration: ContentAnnouncementConfiguration,
        widget: AnnouncementWidget,
        playTimes: PlayTimes
    ) {
        super(configuration, widget, playTimes);
    }

    /**
     * set to true when appropriate content is sized
     */
    #contentSized?: boolean;

    /**
     * handles scheduled content update
     */
    #activeContentScheduler?: SchedulerItem;

    protected renderTemplate(): string {
        return contentTemplate({
            containerElementId: this.containerElementId,
            announcement: {
                name: this.configuration.name,
                id: this.configuration.id,
            },
            widgetid: this.widget.id,
        });
    }

    /**
     * Query API and update content
     */
    updateContent = async (): Promise<void> => {
        const contentDivSelector = `#content_${this.configuration.id}_widget_${this.widget.id}`;
        const content_div = this.widget.wrapperElement.querySelector(contentDivSelector);

        if (!content_div) {
            const errorMessage = `Failed to get content div "${contentDivSelector}" for video announcement (id=${this.configuration.id})`;

            Log.Warning(errorMessage, null, __fileline);

            throw new Error(errorMessage);
        }

        try {
            const results = await ReachAPI.deferredToPromise(
                ReachAPI.rss.getFeedForAnnouncement(this.configuration.content_type)
            );

            const heightOfImage = 768;
            const widthOfImage = 1366;

            const ratio = this.configuration.height / heightOfImage;
            const calculatedImageWidth = Math.ceil(ratio * widthOfImage);
            const context = {
                calculatedImageWidth: calculatedImageWidth,
                calculatedImageHeight: Math.ceil(ratio * heightOfImage),
                calculatedImageLeft: Math.ceil(
                    (this.configuration.width - calculatedImageWidth) / 2
                ),
                calculatedCaptionTop: Math.floor(this.configuration.height - 70),
                announcementId: this.configuration.id,

                image: results.data.feed.items[0].media[0].url,
                title: results.data.feed.items[0].title,
            };

            content_div.innerHTML = contentBodyTemplate(context);
            this.#contentSized = false;
        } catch (error) {
            Log.Warning(
                'Failed to get RSS Feed for the Content Type:' +
                    String(this.configuration.content_type),
                null,
                __fileline,
                { error: error }
            );

            throw error;
        }
    };

    /**
     * announcement initialize method
     *
     * compiles content body, sets up 15 minute update interval
     */
    async initialize(): Promise<void> {
        //todo: replace moment with Luxon
        this.#activeContentScheduler = Scheduler.New()
            .HasAction(this.updateContent)
            .RunEvery(15, 'minutes')
            .Starting(moment().add(15, 'minutes'));

        await this.updateContent();
    }

    async deallocate(): Promise<void> {
        if (this.#activeContentScheduler) {
            Scheduler.Delete(this.#activeContentScheduler.Name);
            this.#activeContentScheduler = undefined;
        }
    }

    async runPage(): Promise<void> {
        if (!this.#contentSized) {
            $(this.widget.wrapperElement).find(`#bftitle_${this.configuration.id}`).textfill();
            this.#contentSized = true;
        }
    }
}

export { AnnouncementContent };
